// The official ixigo logo (orange box, white wordmark) on the ixigo image CDN —
// the same asset the travel-credit-card pages use (ASSETS.ixigoLogo).
export const IXIGO_LOGO = {
	src: 'https://images.ixigo.com/image/upload/payments/cffb53c8f2ee917ffff766330ae3bf7f-qjzpl.png',
	alt: 'ixigo',
	width: 176,
	height: 86,
} as const;
